import dayjs from 'dayjs';
import { v4 as uuid } from 'uuid';
import { englishSuffix } from '../../../services/dates';

export const DEFAULT_SHOPPING_LIST_SERVINGS = 1;

export const MAX_MEALS_TO_ADD_TO_BASKET_AT_ONCE = 30;

const CURRENT_PRODUCTS_BOARD_SCHEMA_VERSION = 1;

const CURRENT_SHOPPING_LIST_SCHEMA_VERSION = 2;

export const newShoppingListWithDefaultFields = (
  productsBoardId,
  shoppingList,
  currentSpaceMembershipID,
) => {
  const input = { ...shoppingList };
  input.schemaVersion = CURRENT_SHOPPING_LIST_SCHEMA_VERSION;
  input.productsBoardID = productsBoardId;
  input.spaceMembershipID = currentSpaceMembershipID;
  return input;
};

export const newProductsBoardWithDefaultFields = (
  currentSpaceMembershipID,
) => ({
  title: 'My Product Lists',
  schemaVersion: CURRENT_PRODUCTS_BOARD_SCHEMA_VERSION,
  spaceMembershipID: currentSpaceMembershipID,
  shoppingListGroups: [
    {
      id: uuid(),
      title: 'My shopping lists',
      shoppingListIDs: [],
    },
  ],
});

export const NEW_SHOPPING_LIST_PSEUDO_ID = '_new';

export const defaultShoppingListTitle = (date) => {
  const day = dayjs(date || new Date());
  const dayStr = `${day.date()}${englishSuffix(day.date())}`;
  const monthStr = day.format('MMMM');
  const yearStr = day.format('YYYY');
  return `Shopping List ${dayStr} ${monthStr} ${yearStr}`;
};

export const shoppingListMealFromMeal = (meal) => {
  /* meal records can come either from the Meal table (id field is the primary key),
     or from the meals list of the ShoppingList Table (mealID field is a unique id referencing the id
     of the Meal table)
   */
  return {
    mealID: meal.id || meal.mealID,
    recipes: meal.recipes.map((recipe) => ({
      title: recipe.title,
      imageUrl: recipe.imageUrl,
      mealiqId: recipe.mealiqId,
      ingredients: recipe.ingredients.map((ing) => ({
        fullText: ing.fullText,
        structuredIngredient: ing.structuredIngredient
          ? {
              name: ing.structuredIngredient.name,
              quantity: ing.structuredIngredient.quantity,
              unitOfMeasure: ing.structuredIngredient.unitOfMeasure,
              linkedIngredient: ing.structuredIngredient.linkedIngredient
                ? {
                    status: ing.structuredIngredient.linkedIngredient.status,
                    linkedIngredientName:
                      ing.structuredIngredient.linkedIngredient
                        .linkedIngredientName,
                  }
                : null,
            }
          : null,
      })),
      servings: recipe.servings,
      preparations: [],
    })),
  };
};
